import { atom, useAtom } from '@gothub-team/got-atom';

export const MouseAtom = atom([0, 0]);
window.addEventListener('mousemove', e => {
    MouseAtom.set([e.clientX, e.clientY]);
});

export const useMouse = () => useAtom(MouseAtom);
